import SandClock from '@/src/assets/svgs/SandClock'
import useRedirectToHome from '@/src/hooks/navigation/useRedirectToHome'
import { Box, Button, Dialog, DialogContent, Stack, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import { FC } from 'react'

interface StillAroundPopupProps {
    handleReFetchWithSameQuery: () => void
}

const StillAroundPopup: FC<StillAroundPopupProps> = ({ handleReFetchWithSameQuery }) => {
    const tCommon = useTranslations('common')
    const goToHome = useRedirectToHome()
    return (
        <Dialog open maxWidth="md" fullWidth>
            <DialogContent>
                <Stack alignItems={'center'} gap={2}>
                    <Box fontSize={'56px'}>
                        <SandClock fontSize="inherit" />
                    </Box>
                    <Box>
                        <Typography variant="h6" textAlign={'center'}>
                            {tCommon('stillAround')}
                        </Typography>

                        <Typography variant="body1" textAlign={'center'}>
                            {tCommon('stillAroundDescription')}
                        </Typography>
                    </Box>

                    <Button fullWidth variant="customVariantPrimary" size="large" onClick={handleReFetchWithSameQuery}>
                        {tCommon('refreshResults')}
                    </Button>

                    <Button fullWidth size="large" onClick={() => goToHome({ isReloadRequired: true })}>
                        {tCommon('startNewFlightSearch')}
                    </Button>
                </Stack>
            </DialogContent>
        </Dialog>
    )
}

export default StillAroundPopup
